import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className"];
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export default function UIScreenReaderOnly(_ref) {
  let {
      children,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    className: classNames('sr-only', className),
    children: children
  }));
}
UIScreenReaderOnly.propTypes = {
  children: PropTypes.node
};
UIScreenReaderOnly.displayName = 'UIScreenReaderOnly';